var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeViewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 12 6.47715 19 12 19C17.5228 19 22 12 22 12C22 12 17.5228 5 12 5C6.47715 5 2 12 2 12ZM4.4688 12C4.92691 12.5847 5.55838 13.3265 6.31925 14.0623C8.0333 15.7198 10.0454 17 12 17C13.9546 17 15.9667 15.7198 17.6807 14.0623C18.4416 13.3265 19.0731 12.5847 19.5312 12C19.0731 11.4153 18.4416 10.6735 17.6807 9.93771C15.9667 8.28015 13.9546 7 12 7C10.0454 7 8.0333 8.28015 6.31925 9.93771C5.55838 10.6735 4.92691 11.4153 4.4688 12Z",
    fill: "#0070DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    fill: "#0070DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeViewIcon);
export default __webpack_public_path__ + "static/media/eye-view-icon.277ff58e1cde3c83c2bf8582196c94a5.svg";
export { ForwardRef as ReactComponent };